"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=autoRegisterRule.js.map